// extracted by mini-css-extract-plugin
export default {"label":"PhoneGroup_label__2dW4y","text":"PhoneGroup_text__1aayZ","phone_flex":"PhoneGroup_phone_flex__oyS0s","phone_sms_container":"PhoneGroup_phone_sms_container__2s1zv"};